import Vue from 'vue'
import { URL_MAILING, URL_LOTS, URL_MANAGEMENT } from '@/constants/urls.js'
import { MAILING, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'
const state = {
  [MAILING.STATE.MAILING_LISTS]: []
}

const actions = {
  async [MAILING.ACTIONS.GET_MAILING_LISTS] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getAdminHost()}${URL_MANAGEMENT}/mailingLists?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(MAILING.MUTATIONS.GET_MAILING_LISTS, resp.data)
  },
  async [MAILING.ACTIONS.EDIT_MAILING_LIST_ITEM] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getAdminHost()}${URL_MANAGEMENT}/mailingLists/${model.mailingType}`,
      model: model.emails
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [MAILING.ACTIONS.SEND_GLOBAL_MAILING] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_MAILING}/global`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [MAILING.ACTIONS.SEND_PARTICIPANTS_MAILING] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_MAILING}/participants`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [MAILING.ACTIONS.SEND_OFFERER_NOTIFICATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/offererNotification`,
      model: {}
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [MAILING.ACTIONS.CLEAR_MAILING_LISTS] ({ commit }) {
    commit(MAILING.MUTATIONS.CLEAR_MAILING_LISTS)
  }
}

const mutations = {
  [MAILING.MUTATIONS.GET_MAILING_LISTS] (state, list) {
    state[MAILING.STATE.MAILING_LISTS] = list
  },
  [MAILING.MUTATIONS.CLEAR_MAILING_LISTS] (state) {
    state[MAILING.STATE.MAILING_LISTS] = []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
